export const mockTableHeaders = [
    {
        key: 'alertName',
        header: 'Alert Name',
        optional: false
    },
    {
        key: 'reportName',
        header: 'Report Name',
        optional: false
    },
    {
        key: 'username',
        header: 'Username',
        optional: false
    },
    {
        key: 'incidentNumber',
        header: 'Incident #',
        optional: false
    },
    {
        key: 'timestamp',
        header: 'Timestamp',
        optional: false
    },
    {
        key: 'bobi',
        header: 'bobi',
        optional: true
    },
    
];

export const mockTableData = [
    {
        id: '1',
        alertName: 'PO  Items blocked',
        reportName: 'Order fullfilment 2%',
        username: 'XYZ',
        incidentNumber: '221',
        timestamp: '12:01 AM',
        optional: false
    },
    {
        id: '2',
        alertName: 'PO  Items blocked',
        reportName: 'Order fullfilment 2%',
        username: 'XYZ',
        incidentNumber: '222',
        timestamp: '12:02 AM',
        optional: false
    },
    {
        id: '3',
        alertName: 'PO  Items blocked',
        reportName: 'Order fullfilment 2%',
        username: 'XYZ',
        incidentNumber: '223',
        timestamp: '12:03 AM',
        optional: false
    },
    {
        id: '4',
        alertName: 'PO  Items blocked',
        reportName: 'Order fullfilment 2%',
        username: 'XYZ',
        incidentNumber: '224',
        timestamp: '12:04 AM',
        optional: false
    },
    {
        id: '5',
        alertName: 'PO  Items blocked',
        reportName: 'Order fullfilment 2%',
        username: 'XYZ',
        incidentNumber: '225',
        timestamp: '12:05 AM',
        optional: false
    },
    {
        id: '6',
        alertName: 'PO  Items blocked',
        reportName: 'Order fullfilment 2%',
        username: 'XYZ',
        incidentNumber: '226',
        timestamp: '12:06 AM',
        optional: false
    },
    {
        id: '7',
        alertName: 'PO  Items blocked',
        reportName: 'Order fullfilment 2%',
        username: 'XYZ',
        incidentNumber: '227',
        timestamp: '12:07 AM',
        optional: false
    },
    {
        id: '8',
        alertName: 'PO  Items blocked',
        reportName: 'Order fullfilment 2%',
        username: 'XYZ',
        incidentNumber: '228',
        timestamp: '12:08 AM',
        optional: false
    },
    {
        id: '9',
        alertName: 'PO  Items blocked',
        reportName: 'Order fullfilment 2%',
        username: 'XYZ',
        incidentNumber: '229',
        timestamp: '12:09 AM',
        optional: false
    },
    {
        id: '10',
        alertName: 'PO  Items blocked',
        reportName: 'Order fullfilment 2%',
        username: 'XYZ',
        incidentNumber: '230',
        timestamp: '12:10 AM',
        optional: false
    },
    {
        id: '11',
        alertName: 'PO  Items blocked',
        reportName: 'Order fullfilment 2%',
        username: 'XYZ',
        incidentNumber: '231',
        timestamp: '12:11 AM',
        optional: false
    },
    {
        id: '12',
        alertName: 'PO  Items blocked',
        reportName: 'Order fullfilment 2%',
        username: 'XYZ',
        incidentNumber: '232',
        timestamp: '12:12 AM',
        optional: false
    },
];

export const expandedTable = [
    {
        id: '1',
        bobi:2,
        bw: 3,
        hana: 128,
        s4Hana: 47
    }
];
export const expandedHeader = [
    {
        key: 'bobi',
        header: 'BOBI',
    },
    {
        key: 'bw',
        header: 'BW',
    },
    {
        key: 'hana',
        header: 'HANA',
    },
    {
        key: 's4Hana',
        header: 'S4 HANA',
    }
];

export const sqlTableHeaders = [
    {
        key: 'statement',
        header: 'Query',
        optional: false
    },
    {
        key: 'duration',
        header: 'Duration (Secs)',
        optional: false
    }
];